import { Period, Producer, Tier } from '../types/commission';

export const tiers: Tier[] = [
  {
    id: 'loan-partner',
    level: 1,
    name: 'Loan Partner',
    subtitle: 'Developmental · 0–6 months',
    baseBps: 60,
    accent: 'brand',
    steps: [
      { units: 0, bps: 60, bonusBps: 0 },
      { units: 4, bps: 65, bonusBps: 5 },
      { units: 6, bps: 80, bonusBps: 20 },
      { units: 10, bps: 90, bonusBps: 30 },
    ],
  },
  {
    id: 'loan-officer',
    level: 2,
    name: 'Loan Officer',
    subtitle: 'Licensed · building pipeline',
    baseBps: 80,
    accent: 'brand',
    steps: [
      { units: 0, bps: 80, bonusBps: 0 },
      { units: 4, bps: 85, bonusBps: 5 },
      { units: 6, bps: 100, bonusBps: 20 },
      { units: 10, bps: 110, bonusBps: 30 },
    ],
  },
  {
    id: 'senior-loan-officer',
    level: 3,
    name: 'Senior Loan Officer',
    subtitle: 'Consistent high production',
    baseBps: 85,
    accent: 'brand',
    steps: [
      { units: 0, bps: 85, bonusBps: 0 },
      { units: 4, bps: 90, bonusBps: 5 },
      { units: 6, bps: 105, bonusBps: 20 },
      { units: 10, bps: 115, bonusBps: 30 },
    ],
  },
  {
    id: 'executive-loan-officer',
    level: 4,
    name: 'Executive Loan Officer',
    subtitle: 'Elite level production',
    baseBps: 90,
    accent: 'gold',
    steps: [
      { units: 0, bps: 90, bonusBps: 0 },
      { units: 4, bps: 95, bonusBps: 5 },
      { units: 6, bps: 110, bonusBps: 20 },
      { units: 10, bps: 120, bonusBps: 30 },
    ],
  },
];

export const producer: Producer = {
  name: 'Marcus Ellery',
  role: 'Senior Loan Officer',
  branch: 'Charlotte, NC · Branch 208',
  nmls: 'NMLS #1184920',
  avatarInitials: 'ME',
};

export const periods: Period[] = [
  {
    id: '2026-08',
    label: 'August 2026',
    shortLabel: 'Aug 2026',
    isCurrent: true,
    daysElapsed: 13,
    daysTotal: 31,
    tierId: 'senior-loan-officer',
    seniorTenureMonths: 14,
    rollingSixMonthUnits: 21,
    scorecard: { points: 11240, goal: 10000 },
    loans: [
      {
        id: 'LN-24817',
        borrower: 'Ana Martinez',
        product: 'Conventional Purchase',
        fundedDate: '2026-08-03',
        amount: 485000,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24853',
        borrower: 'David Chen',
        product: 'Refinance',
        fundedDate: '2026-08-05',
        amount: 312500,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24861',
        borrower: 'Grace Okafor',
        product: 'Conventional Purchase',
        fundedDate: '2026-08-06',
        amount: 598000,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24902',
        borrower: 'Tom Whitfield',
        product: 'FHA Purchase',
        fundedDate: '2026-08-10',
        amount: 274900,
        status: 'closed',
        countsAsUnit: true,
      },
      {
        id: 'LN-24915',
        borrower: 'Sofia Reyes',
        product: 'Conventional Purchase',
        fundedDate: '2026-08-11',
        amount: 412000,
        status: 'closed',
        countsAsUnit: true,
      },
      {
        id: 'LN-24938',
        borrower: 'Kim Nguyen',
        product: 'VA Purchase',
        fundedDate: '2026-08-12',
        amount: 529750,
        status: 'closed',
        countsAsUnit: true,
      },
      {
        id: 'LN-24947',
        borrower: 'Luis Delgado',
        product: 'Refinance',
        fundedDate: '2026-08-13',
        amount: 356200,
        status: 'closed',
        countsAsUnit: true,
      },
      {
        id: 'LN-24980',
        borrower: 'Hannah Brooks',
        product: 'Conventional Purchase',
        fundedDate: '2026-08-24',
        amount: 445000,
        status: 'clear-to-close',
        countsAsUnit: false,
      },
      {
        id: 'LN-25001',
        borrower: 'Rohan Patel',
        product: 'Jumbo Purchase',
        fundedDate: '2026-08-27',
        amount: 812000,
        status: 'clear-to-close',
        countsAsUnit: false,
      },
      {
        id: 'LN-25014',
        borrower: 'Erin Caldwell',
        product: 'FHA Purchase',
        fundedDate: '2026-08-28',
        amount: 268400,
        status: 'clear-to-close',
        countsAsUnit: false,
      },
    ],
  },
  {
    id: '2026-07',
    label: 'July 2026',
    shortLabel: 'Jul 2026',
    isCurrent: false,
    daysElapsed: 31,
    daysTotal: 31,
    tierId: 'senior-loan-officer',
    seniorTenureMonths: 13,
    rollingSixMonthUnits: 19,
    scorecard: { points: 12860, goal: 10000 },
    loans: [
      {
        id: 'LN-24512',
        borrower: 'Priya Raman',
        product: 'Conventional Purchase',
        fundedDate: '2026-07-02',
        amount: 521000,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24537',
        borrower: 'Jared Kowalski',
        product: 'VA Purchase',
        fundedDate: '2026-07-08',
        amount: 389500,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24564',
        borrower: 'Monica Sterling',
        product: 'Jumbo Purchase',
        fundedDate: '2026-07-13',
        amount: 764000,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24601',
        borrower: 'Andre Boone',
        product: 'FHA Purchase',
        fundedDate: '2026-07-17',
        amount: 246800,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24648',
        borrower: 'Lena Fontaine',
        product: 'Refinance',
        fundedDate: '2026-07-22',
        amount: 333400,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24693',
        borrower: 'Victor Alvarado',
        product: 'Conventional Purchase',
        fundedDate: '2026-07-29',
        amount: 458200,
        status: 'paid',
        countsAsUnit: true,
      },
    ],
  },
  {
    id: '2026-06',
    label: 'June 2026',
    shortLabel: 'Jun 2026',
    isCurrent: false,
    daysElapsed: 30,
    daysTotal: 30,
    tierId: 'senior-loan-officer',
    seniorTenureMonths: 12,
    rollingSixMonthUnits: 17,
    scorecard: { points: 8410, goal: 10000 },
    loans: [
      {
        id: 'LN-24288',
        borrower: 'Nathan Brill',
        product: 'Conventional Purchase',
        fundedDate: '2026-06-04',
        amount: 402000,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24311',
        borrower: 'Sonia Vargas',
        product: 'FHA Purchase',
        fundedDate: '2026-06-11',
        amount: 288600,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24359',
        borrower: 'Dean Whitmore',
        product: 'Refinance',
        fundedDate: '2026-06-19',
        amount: 341700,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24402',
        borrower: 'Iris Lindqvist',
        product: 'Conventional Purchase',
        fundedDate: '2026-06-26',
        amount: 512300,
        status: 'paid',
        countsAsUnit: true,
      },
    ],
  },
  {
    id: '2026-05',
    label: 'May 2026',
    shortLabel: 'May 2026',
    isCurrent: false,
    daysElapsed: 31,
    daysTotal: 31,
    tierId: 'senior-loan-officer',
    seniorTenureMonths: 11,
    rollingSixMonthUnits: 15,
    scorecard: { points: 10300, goal: 10000 },
    loans: [
      {
        id: 'LN-24067',
        borrower: 'Camille Duarte',
        product: 'Conventional Purchase',
        fundedDate: '2026-05-07',
        amount: 476500,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24102',
        borrower: 'Owen Baptiste',
        product: 'VA Purchase',
        fundedDate: '2026-05-15',
        amount: 359900,
        status: 'paid',
        countsAsUnit: true,
      },
      {
        id: 'LN-24148',
        borrower: 'Talia Nakamura',
        product: 'Refinance',
        fundedDate: '2026-05-27',
        amount: 298400,
        status: 'paid',
        countsAsUnit: true,
      },
    ],
  },
];
